import React, {useRef, useEffect, useCallback, useState} from 'react';
import {sleep} from 'utils/sleep.js';

const SCROLL_BUFFER = 40;

const MIN_TRACKS = 8;

// AFTER 5 seconds, if the user has not scrolled at all it will
// updat the UX to not render tracks that are not visible
const SLEEP_TIME = 2000;

export const useScroll = ({scrollContainer, trackRef, isSelected, track, tracksToHide, offset=200, useClientBounds=false}) => {
    let [hideInfo, setHideInfo] = useState(undefined);
    let counter = useRef(0);

    const getTop = (element, element2) => useClientBounds ?
          element.offsetTop - element2.offsetTop : element.offsetTop;

    useEffect(() => {
        if (!trackRef.current || !scrollContainer.current) {
            return;
        }

        if (isSelected && !isVisible()) {
            let y = getTop(trackRef.current, scrollContainer.current);
            scrollContainer.current.scrollTo(0, y - offset);
        }
    }, [isSelected, tracksToHide]);

    useEffect(() => {
        if (!scrollContainer.current) {
            return undefined;
        }
        /*
        scrollContainer.current.addEventListener('scroll', onScroll);
        return () => scrollContainer.current ?
            scrollContainer.current.removeEventListener('scroll', onScroll) :
            undefined;
            */
    }, [hideInfo, setHideInfo]);

    const isVisible = (scrollBuffer=SCROLL_BUFFER) => {
        if (!trackRef.current || !scrollContainer.current) {
            return true;
        }

        let scrollTop = scrollContainer.current.scrollTop;
        let scrollHeight = scrollContainer.current.offsetHeight;
        let scrollBottom = scrollTop + scrollHeight;
        
        let trackTop = getTop(trackRef.current, scrollContainer.current);
        let trackHeight = trackRef.current.offsetHeight;
        
        let trackBottom = trackHeight + trackTop;
        
        if (trackBottom < scrollTop + 40 + scrollBuffer || trackTop + scrollBuffer > scrollBottom) {
            return false;
        } else {
            return true;
        }
    };

    const onScroll = useCallback(async () => {
        if (!isVisible(-SCROLL_BUFFER)) {
            // then it should be hidden
            let _counter = ++counter.current;
            await sleep(SLEEP_TIME);
            if (counter.current !== _counter) {
                return;
            }

            if (!isVisible() && !hideInfo) {
                setHideInfo({
                    trackHeight: trackRef.current.offsetHeight
                });
            }
        } else if (hideInfo) {
            setHideInfo(undefined);
        }
        // if track is not in the scroll view then set the visible view
        // otherwise set it to undefined
    }, [hideInfo, setHideInfo]);

    return {hideInfo};
};
